
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import StaticPageTemplate from '@/components/StaticTemplate';
import useTranslation from 'next-translate/useTranslation';
import type { GetStaticProps } from 'next';
import Image from 'next/image';

function MyPage() {
  const { t } = useTranslation();
  const title = t('common:Now With Bevmaq.title');

  const components = [<Text key='text' />];

  return (
    <StaticPageTemplate
      title={title}
      service={false}
      subtitle={''}
      components={components}
      customTitle={<Title />}
    />
  );
}

function Title() {
  const { t } = useTranslation('services');

  return (
    <div>
      <h1 className='mt-2 text-start text-lg text-black md:text-2xl'>
        {t('common:Now With Bevmaq.title')}
      </h1>
      <h1
        className='text-start text-2xl font-semibold text-black md:text-3xl '
        data-testid='header-title'
      >
        {t('common:Now With Bevmaq.subtitle')}
      </h1>
    </div>
  );
}

function Text() {
  const { t } = useTranslation('services');
  const img = t('common:Now With Bevmaq Image');

  return (
    <div className='space-y-7 pb-10'>
      <p className='font-semibold'>{t('common:Now With Bevmaq.text1')}</p>
      <p>{t('common:Now With Bevmaq.text2')}</p>
      <p>{t('common:Now With Bevmaq.text3')}</p>
      <p>{t('common:Now With Bevmaq.text4')}</p>
      <p className='font-semibold text-orange-400'>
        {t('common:Now With Bevmaq.text5')}
        <span className='text-black'>{t('common:Now With Bevmaq.text6')}</span>
      </p>
      <div className='rounded bg-slate-900 px-10 py-5 md:p-28'>
        <div className='relative h-44 max-h-[90%] w-full shrink-0 cursor-pointer bg-slate-900 '>
          <Image
            src={`/${img}`}
            alt='Buy and sell used machinery'
            fill
            className='object-contain'
          />
        </div>
      </div>
      <p>{t('common:Now With Bevmaq.text7')}</p>
      <p className='font-semibold'>{t('common:Now With Bevmaq.text8')}</p>
    </div>
  );
}

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      hasContainer: false,
    },
  };
};

export default MyPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/now-with-bevmaq',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  